export interface IAuthConfig {
    loginEndpoint: string,
    logoutEndpoint: string,
    refreshEndpoint: string,
    resetPasswordEndpoint: string,
    confirmPasswordEndpoint: string,
    switchTenantEndpoint: string,
    switchFacilityEndpoint: string,
    registerDeviceEndpoint: string,
    unregisterDeviceEndpoint: string,
    staffLoginEndpoint: string,
    recoverDeviceRegistrationEndpoint: string,
    ssoAuthUrlEndpoint: string,
    ssoLoginEndpoint: string,
    refreshThresholdMin: number,
    scopes: Array<string>,
}

export default {
    loginEndpoint: 'auth/login',
    logoutEndpoint: 'auth/logout',
    refreshEndpoint: 'auth/refresh',
    resetPasswordEndpoint: 'auth/resetpassword',
    confirmPasswordEndpoint: 'auth/confirmpassword',
    switchTenantEndpoint: 'auth/switchTenant',
    switchFacilityEndpoint: 'auth/switchFacility',
    registerDeviceEndpoint: 'auth/registerDevice',
    unregisterDeviceEndpoint: 'auth/unregisterDevice',
    staffLoginEndpoint: 'auth/stafflogin',
    recoverDeviceRegistrationEndpoint: 'auth/recoverDeviceRegistration',
    ssoAuthUrlEndpoint: 'auth/ssoauthurl',
    ssoLoginEndpoint: 'auth/ssologin',
    refreshThresholdMin: 150, // token lifetime is 180min so refresh each token each 30 min i.e. 150 min before expirison
    scopes: []
} as IAuthConfig;
